import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import IntlMessages from "../../components/IntlMessage";
import {
  Card,
  Table,
  Tag,
  Modal,
  Row,
  Col,
} from "antd";
import PageTitle from "../../components/PageTitle";
import { useIntl } from "react-intl";
import ActionBar from "../../components/ActionBar";
import inviteApi from "../../api/invite";
import moment from "moment-timezone";
moment.tz.setDefault("US/Eastern");

Invite.propTypes = {
  items: PropTypes.array,
};
Invite.defaultProps = {
  items: [],
};
function Invite() {

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(1);
  const [deleting, setDeleting] = useState(false);
  const [loading, setLoading] = useState(true);
  const [reload, setReload] = useState(true);

  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    keyword: "",
    order_by: "id",
    order_dir: "ASC",
  });

  const onChangeTable = async (
    pagination,
    filters,
    sorter,
    extra = { currentDataSource: [] }
  ) => {
    setFilter({
      ...filter,
      page: pagination.current,
      limit: pagination.pageSize,
      order_dir: getOrder(sorter.order),
      order_by: sorter.columnKey ? `${sorter.columnKey}` : "id",
    });
  };

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      let items = await inviteApi.getAll(filter);

      setItems(items.data);
      setLoading(false);
      setDeleting(false);
      if (total !== items.total) setTotal(items.total);
    }
    fetchData();
  }, [filter, deleting, reload]);

  const onReload = () => {
    setReload((reload) => !reload);
  };

  const intl = useIntl();

  const getOrder = (order) => {
    if (order === "ascend") return "ASC";
    if (order === "descend") return "DESC";
    return "ASC";
  };

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const hasSelected = selectedRowKeys.length > 0;

  const onDelete = async (selectedRowKeys) => {
    await inviteApi.delete(selectedRowKeys).catch((error) => {
      console.error(error);
      Modal.error({
        title: error.data.message,
        okText: intl.formatMessage({ id: "global.close" }),
      });
      setLoading(false);
    });
    setDeleting(true);
  };

  const columns = [
    {
      title: <IntlMessages id="global.id_number" />,
      key: "id",
      width: 100,
      dataIndex: "id",
      render: (text, record, index) => {
        return record.id;
      },
    },
    {
      title: <IntlMessages id="global.operator" />,
      key: "operator_title",
      sorter: true,

      dataIndex: "operator_title",
      render: (text, record) => {
        return record.operator.title
      },
    },
    {
      title: <IntlMessages id="global.order" />,
      key: "order_no",
      sorter: true,

      dataIndex: "order_no",
      render: (text, record) => {
        return record.order.order_no
      },
    },
    {
      title: <IntlMessages id="invite.invite_status" />,
      key: "invite_status",
      sorter: true,

      dataIndex: "invite_status",
      render: (text, record) => {
        return record.invite_status === "pending" ? (
          <Tag color="processing">{record.invite_status}</Tag>
        ) : record.invite_status === "accepted" ? (
          <Tag color="success">{record.invite_status}</Tag>
        ) : (
          <Tag color="error">{record.invite_status}</Tag>
        );
      },
    },

    {
      title: <IntlMessages id="invite.qty" />,
      key: "qty",
      sorter: true,

      dataIndex: "qty",
      render: (text, record) => {
        return `${record.qty}`;
      },
    },
  ];
  return (
    <Card bordered={false} style={{ minHeight: "100%" }}>
      <Row justify="space-between">
        <Col>
          {" "}
          <PageTitle title={<IntlMessages id="global.invite" />} />
          {/* <Button
            type="primary"
            size="small"
            onClick={() => onMultiRemove(selectedRowKeys)}
            danger
            shape="round"
            disabled={!hasSelected}
            icon={<DeleteOutlined />}
          >
            <IntlMessages id="global.delete" />
          </Button> */}
        </Col>

        <Col>
          <ActionBar
            onDelete={() => onDelete(selectedRowKeys)}
            isShowAddButton={false}
            //onAdd={onOpenModal}
            onRefresh={() => onReload()}
            isShowPublishButtons={false}
            isShowCopyButton={false}
            isShowDeleteButton={true}
            isDisabled={!hasSelected}
          ></ActionBar>
        </Col>
      </Row>

      {/* <FilterBar

                onFilter={onFilter}
                data={[
                    {
                        name: "category",
                        data: categories,
                        placeholder: <IntlMessages id="global.select_category" />,
                    },

                ]}

            >
            </FilterBar> */}

      <Table
        tableLayout="auto"
        columns={columns}
        dataSource={items}
        onChange={onChangeTable}
        rowKey="id"
        rowSelection={rowSelection}
        size="small"
        loading={loading}
        scroll={{
          x: "max-content",
        }}
        pagination={{
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50"],
          total: total,
          current: filter.page,
          pageSize: filter.limit,
        }}
      />
    </Card>
  );
}

export default Invite;
